import ResourceManager from "@/pages/admin/components/ResourceManager";
import type { ColumnConfig, FieldConfig } from "@/lib/adminFields";

const tipoLabels: Record<string, string> = {
  imagen: "Imagen",
  video: "Video",
};

const fields: FieldConfig[] = [
  { name: "titulo", label: "Título", type: "text", required: true, full: true, placeholder: "Texto principal del héroe" },
  { name: "subtitulo", label: "Subtítulo", type: "textarea", full: true },
  {
    name: "tipo",
    label: "Tipo de medio",
    type: "select",
    options: [
      { value: "imagen", label: "Imagen" },
      { value: "video", label: "Video" },
    ],
  },
  { name: "orden", label: "Orden", type: "number", help: "Número menor aparece primero" },
  { name: "activo", label: "Visible en el sitio", type: "switch" },
  {
    name: "url",
    label: "Imagen o video",
    type: "image",
    full: true,
    folder: "hero",
    help: "Sube una imagen o pega la URL de la imagen / video",
  },
];

const columns: ColumnConfig[] = [
  { name: "url", label: "Vista previa", type: "image" },
  { name: "titulo", label: "Título" },
  { name: "tipo", label: "Tipo", type: "muted" },
  { name: "orden", label: "Orden", type: "muted" },
  { name: "activo", label: "Visibilidad", type: "switch" },
];

export default function AdminHero() {
  return (
    <ResourceManager
      table="hero_media"
      title="Héroe y medios"
      description="Controla las diapositivas del banner principal: imágenes o videos, título, subtítulo y orden."
      itemSingular="diapositiva"
      itemPlural="diapositivas"
      emptyIcon="ri-image-line"
      titleField="titulo"
      subtitleField="tipo"
      imageField="url"
      searchPlaceholder="Buscar por título…"
      fields={fields}
      columns={columns}
      renderCell={(row, column) => {
        if (column.name === "tipo") {
          return (
            <span className="text-sm text-foreground-600">
              {tipoLabels[String(row.tipo)] ?? String(row.tipo ?? "—")}
            </span>
          );
        }
        return undefined;
      }}
    />
  );
}